import { render } from "./OrgSwitcher.vue?vue&type=template&id=1ea85b1e&scoped=true"
import script from "./OrgSwitcher.vue?vue&type=script&lang=js"
export * from "./OrgSwitcher.vue?vue&type=script&lang=js"

import "./OrgSwitcher.vue?vue&type=style&index=0&id=1ea85b1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea85b1e"]])

export default __exports__